import { jsx as _jsx } from "react/jsx-runtime";
import InputMask from 'react-input-mask';
import { onMaskedStateChange } from '../../utils/react-input-mask-helpers';
import { Input } from '../input';
/**
 * Unmasks a masked phone value
 * @param event
 * @returns tuple of raw entry an formatted value
 */
export const unmaskZipCode = (maskedValue) => maskedValue.replace(/[^0-9.]/g, '');
/**
 * Phone Input with North American Standard Format ()
 */
export const ZipCodeInput = ({ value, label, disabled, onChange, ...rest }) => {
    // if zip+ 4 is desired use '99999-9999`;
    // const [mask, setMask] = useState('99999');
    // // Only use this with zip + 4
    // const onZipBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    //   if (e.currentTarget === e.target) {
    //     const rawInput = e.target.value.replace(/[^0-9.]/g, '');
    //     if (rawInput.length === 5 || rawInput.length < 9) {
    //       setMask('99999');
    //     }
    //   }
    // };
    // Only use with zip + 4
    // const onZipFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    //   if (e.currentTarget === e.target) {
    //     setMask('99999-9999');
    //   }
    // };
    /**
     * Will unmask and uplift the changed zip-code number value
     * @param event
     */
    const onChangeInput = (event) => {
        // eslint-disable-next-line no-param-reassign
        event.target.value = unmaskZipCode(event.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    const mask = '99999';
    return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    _jsx(InputMask, { mask: mask, onChange: onChangeInput, disabled: disabled, value: value, ...rest, onBlur: (e) => {
            // onZipBlur(e);     // Only needed for zip+ 4 - restore previous code
            // For Formik
            if (rest === null || rest === void 0 ? void 0 : rest.onBlur) {
                rest.onBlur(e);
            }
        }, beforeMaskedStateChange: (state) => onMaskedStateChange(state, mask, unmaskZipCode), children: _jsx(Input, { id: rest.id, label: label }) }));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiWmlwQ29kZUlucHV0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvemlwY29kZS1pbnB1dC9aaXBDb2RlSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFFQSxPQUFPLFNBQVMsTUFBTSxrQkFBa0IsQ0FBQztBQUN6QyxPQUFPLEVBQUUsbUJBQW1CLEVBQUUsTUFBTSxzQ0FBc0MsQ0FBQztBQUMzRSxPQUFPLEVBQUUsS0FBSyxFQUFFLE1BQU0sVUFBVSxDQUFDO0FBTWpDOzs7O0dBSUc7QUFDSCxNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsQ0FBQyxXQUFtQixFQUFVLEVBQUUsQ0FDM0QsV0FBVyxDQUFDLE9BQU8sQ0FBQyxVQUFVLEVBQUUsRUFBRSxDQUFDLENBQUM7QUFFdEM7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxZQUFZLEdBQWdDLENBQUMsRUFDeEQsS0FBSyxFQUNMLEtBQUssRUFDTCxRQUFRLEVBQ1IsUUFBUSxFQUNSLEdBQUcsSUFBSSxFQUNSLEVBQUUsRUFBRTtJQUNILHlDQUF5QztJQUN6Qyw2Q0FBNkM7SUFFN0MsZ0NBQWdDO0lBQ2hDLGlFQUFpRTtJQUNqRSx3Q0FBd0M7SUFDeEMsK0RBQStEO0lBQy9ELDBEQUEwRDtJQUMxRCwwQkFBMEI7SUFDMUIsUUFBUTtJQUNSLE1BQU07SUFDTixLQUFLO0lBRUwsd0JBQXdCO0lBQ3hCLGtFQUFrRTtJQUNsRSx3Q0FBd0M7SUFDeEMsNkJBQTZCO0lBQzdCLE1BQU07SUFDTixLQUFLO0lBQ0w7OztPQUdHO0lBQ0gsTUFBTSxhQUFhLEdBQUcsQ0FBQyxLQUFvQyxFQUFFLEVBQUU7UUFDN0QsNkNBQTZDO1FBQzdDLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBSyxHQUFHLGFBQWEsQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ3ZELFFBQVEsYUFBUixRQUFRLHVCQUFSLFFBQVEsQ0FBRyxLQUFLLENBQUMsQ0FBQztJQUNwQixDQUFDLENBQUM7SUFFRixNQUFNLElBQUksR0FBRyxPQUFPLENBQUM7SUFFckIsT0FBTztJQUNMLDZEQUE2RDtJQUM3RCxhQUFhO0lBQ2IsS0FBQyxTQUFTLElBQ1IsSUFBSSxFQUFFLElBQUksRUFDVixRQUFRLEVBQUUsYUFBYSxFQUN2QixRQUFRLEVBQUUsUUFBUSxFQUNsQixLQUFLLEVBQUUsS0FBSyxLQUVSLElBQUksRUFDUixNQUFNLEVBQUUsQ0FBQyxDQUFDLEVBQUUsRUFBRTtZQUNaLHNFQUFzRTtZQUN0RSxhQUFhO1lBQ2IsSUFBSSxJQUFJLGFBQUosSUFBSSx1QkFBSixJQUFJLENBQUUsTUFBTSxFQUFFLENBQUM7Z0JBQ2pCLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFDakIsQ0FBQztRQUNILENBQUMsRUFDRCx1QkFBdUIsRUFBRSxDQUFDLEtBQUssRUFBRSxFQUFFLENBQ2pDLG1CQUFtQixDQUFDLEtBQUssRUFBRSxJQUFJLEVBQUUsYUFBYSxDQUFDLFlBSWpELEtBQUMsS0FBSyxJQUFDLEVBQUUsRUFBRSxJQUFJLENBQUMsRUFBRSxFQUFFLEtBQUssRUFBRSxLQUFLLEdBQUssR0FDM0IsQ0FDYixDQUFDO0FBQ0osQ0FBQyxDQUFDIn0=